import { render, staticRenderFns } from "./CodeBlockTabSet.vue?vue&type=template&id=baae12a8"
import script from "./CodeBlockTabSet.vue?vue&type=script&lang=js"
export * from "./CodeBlockTabSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('baae12a8')) {
      api.createRecord('baae12a8', component.options)
    } else {
      api.reload('baae12a8', component.options)
    }
    module.hot.accept("./CodeBlockTabSet.vue?vue&type=template&id=baae12a8", function () {
      api.rerender('baae12a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/js/components-wa/code/CodeBlockTabSet.vue"
export default component.exports